import ValaszDto from 'app/admin/valasz/dto/ValaszDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class ValaszTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'valaszTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, ValaszDto)))
				.catch(reject);
		});
	}
}

export default new ValaszTableService();
